module.exports = __webpack_public_path__ + "img/25@2x.2088031.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/25@2x.png
// module id = JF89
// module chunks = 0